import type WaveSurfer from "wavesurfer.js";

// Cross-origin audio can play via <audio>, but WaveSurfer/fetch need CORS.
export function isCrossOriginAudioUrl(url: string): boolean {
  if (!url || url.startsWith("blob:") || url.startsWith("data:")) return false;
  try {
    return new URL(url, window.location.href).origin !== window.location.origin;
  } catch {
    return false;
  }
}

// Peaks so WaveSurfer skips fetchBlob (CORS) and still paints a styled waveform.
export function createSyntheticPeaks(length = 512): Float32Array {
  const data = new Float32Array(length);
  for (let i = 0; i < length; i++) {
    const t = i / length;
    data[i] =
      0.4 * Math.sin(2 * Math.PI * t * 7) +
      0.25 * Math.sin(2 * Math.PI * t * 17) +
      0.15 * Math.sin(2 * Math.PI * t * 31) +
      0.08 * Math.sin(2 * Math.PI * t * 53);
  }
  return data;
}

export async function loadWaveSurferAudio(
  ws: WaveSurfer,
  audioUrl: string,
): Promise<void> {
  if (isCrossOriginAudioUrl(audioUrl)) {
    await ws.load(audioUrl, [createSyntheticPeaks()]);
    return;
  }
  await ws.load(audioUrl);
}
